import React, { Component } from 'react';
import { Redirect }         from 'react-router';
import Vendor               from './Vendor';
import './App.css';

class App extends Component {
    
  constructor(props) {
    super(props)
    this.state = {
        
    }
  }  
    
  render() {
    if (this.props.location.pathname === '/') {
      return (
        <Redirect to="/catalog" push />
      );
    }
    else {
      return (
        <div className='App'>
          <Vendor />
        </div>
      );
    }
  }
}

export default App;
